import { Row, Col, Button, Tooltip, Spinner } from 'reactstrap';
import styles from './VendorPage.module.scss';
import SideBar from '../../global/Components/SideBar/SideBar';
import Layout from '../../layout/Layout';
import { useState, useRef } from 'react';
import VendorCard from './Sections/VendorCard';
import { useToggle } from '../../global/utils/hooks/useToggle';
import { useParams, Link } from 'react-router-dom';
import { getRequest } from '../../global/utils/apiCall';
import { useEffect } from 'react';
import TabItem from '../../global/Components/Tab/TabItem/TabItem';
import TabContents from '../../global/Components/Tab/TabContent/TabContents';
import ProductOnSale from './Sections/ProductOnSale';
import LastQuestion from './Sections/LastQuestion';
import FeedbackList from '../../global/Components/Feedback/FeedbackList';
import SEO from '../../global/Components/SEO/SEO';
import { Toast } from 'primereact/toast';

const USER_URL = 'api/v1/user';

export default function VendorPage() {
  const { id } = useParams();
  const toast = useRef(null);

  const [user, setUser] = useState();

  const [successMsg, setSuccessMsg] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [tooltipOpen, setTooltipOpen,toggleTooltipOpen] = useToggle(false);

  const shareUrl = window.location.href;
  
  const [activeTab, setActiveTab] = useState(0);

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const handleTabClick = (tabId) => {
      setActiveTab(tabId);
    };

  useEffect(() => {
      setActiveTab('product-on-sale');
  },[]);

  async function shareHandleClick() {
      await navigator.clipboard.writeText(shareUrl);
      setSuccessMsg("Copied");
      setTooltipOpen(true);
      setTimeout(function(){
          setTooltipOpen(false);
          setSuccessMsg('');
      },1000)
  }

  const callVendor = async () => {
    setIsLoading(true);

    try {
      const response = await getRequest(`${USER_URL}/${id}`);
      setUser(response.data.data);
      setIsLoading(false);
    }
    catch (error){
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      }  
      setIsLoading(false);
    }
    finally{
      setIsLoading(false);
    }
  }
    
  useEffect(() => {
    callVendor();
  },[]);

  return (
    <vendorpage-component>
      <SEO title={user && `${user.username}`} />
      <Toast ref={toast} position="top-center" />

      <Layout>
          {
              successMsg && (
                  <Tooltip
                      isOpen={tooltipOpen}
                      target='sharePage'>
                      {successMsg}
                  </Tooltip>
              )
              
          }
          <div className={`container-xxl`}>
              <Row className={`pt-5 pb-3`}>
                  <SideBar xs={12} sm={12} md={12} lg={3}>
                      {
                        isLoading 
                        ? (
                          <>
                            <Spinner color='primary' className='mx-auto'>
                              Loading...
                            </Spinner>
                          </>
                        ) 
                        : (
                            user &&
                              <VendorCard data={user}/>
                        )
                      }
                  </SideBar>
                  <Col xs={12} sm={12} md={12} lg={9}>
                      <div className={`bg-white p-4 ${styles.lgtBackground}`}>
                          <Row>
                              <Col>
                                  {/* <Button className={`me-2 btn-sm ${styles.borderBtn}`}>
                                      Send a private message
                                      <i className="bi bi-envelope ps-2"></i>
                                  </Button> */}
                                  <Link to={`/product-list/?user_id=${id}`} className={`me-2 btn btn-secondary btn-sm ${styles.borderBtn}`}>
                                      Visit the store
                                      <i className="bi bi-shop-window ps-2"></i>
                                  </Link>
                                  <Button 
                                      onClick={shareHandleClick}
                                      rel="noreferrer"
                                      id='sharePage'
                                      className={`me-2 btn-sm ${styles.borderBtn}`}>
                                      <i className="bi bi-share"></i>
                                  </Button>
                                  {/* <Button className={`me-2 btn-sm ${styles.borderBtn}`}>
                                      <i className="bi bi-bookmark"></i>
                                  </Button> */}
                              </Col>
                          </Row>
                          <Row>
                            <Col md={12} className='pt-4'>
                              <div className={`${styles.tabNav} sticky-top bg-white`}>
                                <TabItem  id={'product-on-sale'} title={'Products on sale'} icon={'bi bi-box-seam me-2'} type={'product-on-sale'} activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} handleTabClick={handleTabClick}></TabItem>
                                <TabItem  id={'product-comment'} title={'Last Question'} icon={'bi bi-chat-left-text'} type={'product-comment'} activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} handleTabClick={handleTabClick}></TabItem>
                                <TabItem  id={'feedback'} title={'Feedback'} icon={'bi bi-emoji-smile'} type={'feedback'} activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} handleTabClick={handleTabClick}></TabItem>
                              </div>
                              <div className={`pt-4`}>
                                <TabContents>
                                  {activeTab === 'product-on-sale' && <ProductOnSale userId={id} />}
                                  {activeTab === 'product-comment' && <LastQuestion userId={id} />}
                                  {activeTab === 'feedback' && <FeedbackList userId={id} deleteBtn={false} />}
                                </TabContents>
                              </div>
                            </Col>
                          </Row>
                      </div>
                  </Col>
              </Row>
          </div>
      </Layout>
    </vendorpage-component>
  )
}
